import { Toaster } from "sonner";
import * as styles from "@styles/Toaster.css";

export default function AppToaster() {
  return (
    <Toaster
      richColors
      position="top-right"
      toastOptions={{
        className: styles.toast,
      }}
    />
  );
}
